import React, {useState} from "react";
import useInput from "../../hooks/useInput";
import {formatDate, getFirstDayOfWeek, getLastDayOfWeek} from "../../utils";
import {Box, Columns, Form, Table} from "react-bulma-components";
import {useSummaryFiguresData} from "../../hooks/useSummaryFiguresData";
import LoadingSpinner from "../Utils/Spinner";
import Figure from "../Utils/Figure";
import {useSelector} from "react-redux";
import {getSummaryFiguresData} from "../../state/selectors";
import Collapsible from "react-collapsible";


export default function FigureSummary({selectedDepartment}){
    const getProfit = () => {
        return Math.round( (data.total_income - data.total_expense)*100 ) / 100
    }

    const getProfitVsTarget = () => {
        return Math.round( (getProfit() - data.target) * 100 ) / 100;
    }

    const getColour = (value, invert=false) => {
        if(value === 0){
            // Due to invert and the 0 being captured in red by default it causes expense to be the wrong colour at 0 value
            return
        }

        let returnValue;
        if(value <= 0){
            returnValue = -1
        }
        if(value > 0){
            returnValue = 1
        }
        if(invert){
            returnValue = returnValue * -1;
        }
        if(returnValue === 1){
            return "table-highlight-green-black-text"
        }
        else{
            return "table-highlight-red"
        }
    }


    const onWeekSelect = e => {
        let first = getFirstDayOfWeek(new Date(e.target.value));
        let finish_date = getLastDayOfWeek(first);
        console.log(first, finish_date, e.target.value);
        setStart(first);
        setEnd(finish_date);
    };

    const [start, setStart] = useState(getFirstDayOfWeek(new Date()));
    const [end, setEnd] = useState(getLastDayOfWeek(start))


    let params = {
        department: selectedDepartment
    };

    if(start){
        params.start = formatDate(start);
    }
    if(end){
        params.end = formatDate(end);
    }

    let loaded = useSummaryFiguresData(params);
    let data = useSelector(getSummaryFiguresData);


    if(!loaded){
        return <LoadingSpinner/>
    }

    return (
        <Box>
            <Collapsible
                trigger={"Figures"}
                triggerOpenedClassName={"title"}
                triggerClassName={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Input
                            name={"start"}
                            value={formatDate(start)}
                            onChange={onWeekSelect}
                            type={"date"}
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>End Date</Form.Label>
                        <Form.Input
                            name={"end"}
                            value={formatDate(end)}
                            disabled={true}
                            type={"date"}
                        />
                    </Columns.Column>
                    <Columns.Column></Columns.Column>
                    <Columns.Column></Columns.Column>
                    <Columns.Column></Columns.Column>
                    <Columns.Column></Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <text>These figures are the total income and expense across the entire business.</text>
                    </Columns.Column>
                </Columns>
                {/*<Columns>*/}
                {/*    <Columns.Column></Columns.Column>*/}
                {/*    <Columns.Column></Columns.Column>*/}
                {/*</Columns>*/}
                <Columns>
                    <Columns.Column>
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>Total Income</th>
                                    <th>Total Expense CF</th>
                                    <th>Profit</th>
                                    <th>Target</th>
                                    <th>Profit Vs Target</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className={getColour(data.total_income)}>{Math.round(data.total_income*100)/100}</td>
                                    <td className={getColour(data.total_expense, true)}>{Math.round(data.total_expense*100)/100}</td>
                                    <td className={getColour(getProfit())}>{getProfit()}</td>
                                    <td>{Math.round(data.target * 100) / 100}</td>
                                    <td className={getColour(getProfitVsTarget())}>{getProfitVsTarget()}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>

    )
}